<template>
  <wa-element-loading
    v-if="isLoading"
    class="display-flex flex-column flex-items-center flex-content-center"
    line-length="md"
    :content="`Loading the in-progress icon requests. Patience you must have.`"
    :custom-style="{
      'min-height': 'var(--element-md-loading-min-height)'
    }"
  />
  <transition
    v-else
    enter-active-class="animate__animated animate__faster animate__fadeIn"
  >
    <main role="main">
      <table
        summary="The most requested icons that are in progress"
        class="roomy striped"
      >
        <thead>
          <tr>
            <th
              scope="col"
              class="text-nowrap requests-col-sm"
            >
              Status
            </th>
            <th
              scope="col"
              class="text-nowrap"
            >
              Name
            </th>
            <th
              scope="col"
              class="text-nowrap requests-col-sm"
            >
              <abbr
                title="number"
                class="sr-only"
              >
                Number of
              </abbr>
              Comments
            </th>
            <th
              scope="col"
              class="text-nowrap requests-col-sm"
            >
              <abbr
                title="number"
                class="sr-only"
              >
                Number of
              </abbr>
              Reactions
            </th>
          </tr>
        </thead>
        <tbody>
          <requests-row
            v-for="iconRequest in iconRequests"
            :key="iconRequest.id"
            :request-url="iconRequest.url"
            :request-title="formattedTitle(iconRequest)"
            :request-comments-total="iconRequest.commentsTotal"
            :request-reactions-total="iconRequest.reactionsTotal"
            is-in-progress
          />
        </tbody>
      </table>
    </main>
  </transition>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { LeaderboardMixin } from './mixins'
  import RequestsRow from './components/RequestsRow'

  export default {
    name: 'InProgressIcons',

    components: {
      RequestsRow
    },

    mixins: [LeaderboardMixin],

    data() {
      return {
        isLoading: true
      }
    },

    computed: {
      ...mapGetters('community', ['iconRequests'])
    },

    created() {
      this.fetchIconRequests({ type: 'inprogress' }).then(() => (this.isLoading = false))
    },

    methods: {
      ...mapActions('community', ['fetchIconRequests'])
    }
  }
</script>
